import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Hyperlink, Image } from '@openedx/paragon';

import messages from './messages';
import footerLogo from '../../../assets/footerlogo.png';

const LargeLayout = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="old-login-layout">
      <div className="old-login-left">
        <Hyperlink destination={getConfig().MARKETING_SITE_BASE_URL}>
          <Image
            src={footerLogo}
            alt={getConfig().SITE_NAME}
            className="old-login-logo"
          />
        </Hyperlink>

        <div className="old-login-text">
          <h1>
            {formatMessage(messages['start.learning'])}
            <br />
            <span className="old-login-site-name">
              {formatMessage(messages['with.site.name'], { siteName: getConfig().SITE_NAME })}
            </span>
          </h1>
        </div>
      </div>

      <div className="old-login-right" />
    </div>
  );
};

export default LargeLayout;
